/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Wed Nov 22 2023
 **/

import { forwardRef } from "react";

import * as S from "./private/emotion";

interface IBannerProps {
	Text: typeof TextBannerComp;
}

export interface ITextBannerProps {
	children: React.ReactNode;
}

const TextBannerComp = forwardRef((props: ITextBannerProps, ref: React.Ref<HTMLDivElement>) => {
	return <S.TextBannerWrapper ref={ref} verticalAlign="center" {...props} />;
});

const Banner = {
	...TextBannerComp,
	Text: TextBannerComp
} as IBannerProps;

export default Banner;
